import { Component, Input } from '@angular/core';
import { PartyStatusColumnDef, PartyStatusDto } from "../../../pages/election-overview/election-overview.model";
import { CandidateDataLoadState, ResultSummaryDto } from "@shared/clients/api.generated";

@Component({
  selector: 'valg-dk-party-voting-status-summary',
  templateUrl: './party-voting-status-summary.component.html'
})
export class PartyVotingStatusSummaryComponent {
  @Input() partyStatus: PartyStatusDto[] = [];
  @Input() candidateDataLoadState: CandidateDataLoadState = CandidateDataLoadState.NotLoaded;
  @Input() resultSummary?: ResultSummaryDto; 
  partyStatusColumnDef = PartyStatusColumnDef;
  protected readonly CandidateDataLoadState = CandidateDataLoadState;
}
